var MenuTypes;
(function (MenuTypes) {
    MenuTypes["MenuItem"] = "menu-item";
    MenuTypes["Contact"] = "contact";
    MenuTypes["Redirect"] = "redirect";
    MenuTypes["Step"] = "step";
    MenuTypes["Cancel"] = "cancel";
    MenuTypes["ToUseDesk"] = "toUseDesk";
})(MenuTypes || (MenuTypes = {}));

export { MenuTypes };
//# sourceMappingURL=MenuTypes.js.map
